import React from 'react';
import Icon from '~/app/common/Icon';
import useTranslation from '~/app/hooks/useTranslation';
import classes from './style.module.scss';
import { IssueOrServiceType } from '~/app/data/statuses/chat';

export type EmptyMessageComponent = React.FC<{ type: IssueOrServiceType }>

const EmptyMessage: EmptyMessageComponent = ({ type }) => {
    const { t } = useTranslation(type === IssueOrServiceType.ISSUE ? 'issues': 'services');

    return (
        <div className={classes['message']}>
            <Icon className={classes['icon']} name="terrain" size="60"/>
            <div className={classes['title']}>{t('empty')}</div>
        </div>
    );
};

export default EmptyMessage
